/* ═══════════════════════════════════════════════════════════
   NATULIM QUIZ v3.0 FR — JS (CaaS + Shipment Boxes)
   France (natulimfr.myshopify.com) — ⚠️ NE PAS MODIFIER natulim-quiz.js
   ═══════════════════════════════════════════════════════════ */
(function() {
'use strict';
if (window._ntlQuizFR) return;

const PRODUCTS = {
  det40: {
    name:'Éco-Feuilles de Lessive - 40 Lavages', handle:'eco-feuilles-lessive-40-lavages',
    id:'7208913993899', price:11.47, compareAt:13.50, category:'Lessive',
    img:'', frequencies:['30d','60d','90d'], lavBote:40, hasFragrance:true,
    variants:{ 'Floral':'41425768022187','Lavande':'42391251124395','Sans parfum (peau sensible & bébé)':'41425768054955' },
    variantImages:{}
  },
  det360: {
    name:'Pack annuel - 12x Boîtes', handle:'pack-12x-boites-eco-feuilles-de-lessive',
    id:'8826836975948', price:121.00, compareAt:162.00, category:'Lessive',
    img:'', frequencies:['10m','12m','18m'], lavBote:480, hasFragrance:true,
    variants:{ 'Floral':'47574875341132','Lavande':'47574875439436','Sans parfum':'47574875373900' },
    variantImages:{}
  },
  oxis: {
    name:'Oxi Clean - Booster de lavage', handle:'oxi-clean',
    id:'8852139475276', price:10.20, compareAt:12.00, category:'Lessive',
    img:'', frequencies:['30d','60d','90d','120d'], lavBote:41.67, gPerLav:12,
    variants:{ 'Default':'47663428632908' }
  },
  oxiwhite: {
    name:'Oxi White – Poudre Blanchissante', handle:'oxi-white',
    id:'8852140425548', price:10.20, compareAt:12.00, category:'Lessive',
    img:'', frequencies:['30d','60d','90d','120d'], lavBote:41.67, gPerLav:12,
    variants:{ 'Default':'47663431614796' }
  },
  perles: {
    name:'Perles parfumées Natulim', handle:'perles-parfumees',
    id:'', price:8.07, compareAt:9.50, category:'Lessive',
    img:'', frequencies:['30d','60d','90d'], hasFragrance:true,
    variants:{ 'Floral':'52263849394508','Lavande':'52263849427276','Aurora':'52263849460044' },
    variantImages:{}
  },
  rec_perles: {
    name:'Refill Perles Parfumées', handle:'refill-perles-parfumees',
    id:'', price:8.07, compareAt:9.50, category:'Lessive',
    img:'', frequencies:['30d','60d','90d'], hasFragrance:true,
    variants:{ 'Floral':'52263951368524','Lavande':'52263951401292','Aurora':'52263951434060' },
    variantImages:{}
  },
  detachant: {
    name:'Détachant + 2 éponges', handle:'detachant-2-eponges',
    id:'8598626402636', price:15.21, compareAt:17.90, category:'Lessive',
    img:'', frequencies:['4m','8m','12m'],
    variants:{ 'Default':'46749913940300' }
  },
  pastillas: {
    name:'2x30 Tablettes Lave-Vaisselle', handle:'tablettes-lave-vaisselle',
    id:'8684523913548', price:17.76, compareAt:20.90, category:'Cuisine',
    img:'', frequencies:['60d','90d','120d'],
    variants:{ 'Default':'47417928286540' }
  },
  lavmano: {
    name:'Pack Lave-Vaisselle à la main', handle:'pack-lave-vaisselle-a-main-ecologique',
    id:'9324536856908', price:15.99, compareAt:19.00, category:'Cuisine',
    img:'', frequencies:['3m','6m','12m'],
    variants:{ 'Default':'49026994962764' }
  },
  lavmanopoudre: {
    name:'Lave-Vaisselle à la main Écologique', handle:'lave-vaisselle-a-main-ecologique',
    id:'9322914513228', price:7.56, compareAt:8.90, category:'Cuisine',
    img:'', frequencies:['3m','6m','12m'],
    variants:{ 'Default':'49018830717260' }
  },
  friegasuelos: {
    name:'Nettoyant Sols en Feuilles - 30 Doses', handle:'nettoyant-sols-en-feuilles-30-doses',
    id:'7424194937003', price:8.92, compareAt:10.50, category:'Maison',
    img:'', frequencies:['30d','60d','90d','120d'],
    variants:{ 'Default':'42066886295723' }
  },
  flisflis: {
    name:'Pack Essentiels Maison', handle:'pack-les-4-indispensables',
    id:'14878534074700', price:33.50, compareAt:50.00, category:'Maison',
    img:'', frequencies:['3m','6m','12m'],
    variants:{ '2 de chaque':'52537221775692','4 de chaque':'52537221808460','6 de chaque':'52537221841228' },
    variantPrices:{
      '2 de chaque':{price:33.50,compareAt:50.00},
      '4 de chaque':{price:55.00,compareAt:76.00},
      '6 de chaque':{price:77.00,compareAt:102.00}
    }
  },
  antical: {
    name:'Pack Anti-Calcaire', handle:'pack-anti-calcaire',
    id:'', price:10.06, compareAt:12.50, category:'Maison',
    img:'', frequencies:['3m','6m','12m'],
    variants:{ '2':'52541149053260','4':'52541149086028','6':'52541149118796' },
    variantPrices:{ '2':{price:10.06,compareAt:12.50},'4':{price:16.00,compareAt:20.00},'6':{price:22.00,compareAt:28.00} }
  },
  degraissant: {
    name:'Pack Dégraissant', handle:'pack-degraissant',
    id:'14878604591436', price:10.06, compareAt:12.50, category:'Maison',
    img:'', frequencies:['3m','6m','12m'],
    variants:{ '2':'52537519014220','4':'52537519046988','6':'52537519079756' },
    variantPrices:{ '2':{price:10.06,compareAt:12.50},'4':{price:16.00,compareAt:20.00},'6':{price:22.00,compareAt:28.00} }
  },
  vitres: {
    name:'Pack Nettoyant Vitres', handle:'pack-nettoyant-vitres',
    id:'14879569936716', price:10.06, compareAt:12.50, category:'Maison',
    img:'', frequencies:['3m','6m','12m'],
    variants:{ '2':'52541223076172','4':'52541223108940','6':'52541223141708' },
    variantPrices:{ '2':{price:10.06,compareAt:12.50},'4':{price:16.00,compareAt:20.00},'6':{price:22.00,compareAt:28.00} }
  },
  multisurfaces: {
    name:'Pack Multi-Surfaces', handle:'pack-multi-surfaces-1',
    id:'', price:10.06, compareAt:12.00, category:'Maison',
    img:'', frequencies:['3m','6m','12m'],
    variants:{ '2':'52558241431884','4':'52558241464652','6':'52558241497420' },
    variantPrices:{ '2':{price:10.06,compareAt:12.00},'4':{price:16.00,compareAt:19.00},'6':{price:22.00,compareAt:26.00} }
  },
  rec_antical: {
    name:'Sachets Recharges Anti-calcaire', handle:'sachets-recharges-anti-calcaire',
    id:'', price:4.68, compareAt:5.51, category:'Maison',
    img:'', frequencies:['3m','6m','12m'],
    variants:{ '2':'52542086578508','4':'52542086611276','6':'52542086644044' },
    variantPrices:{ '2':{price:4.68},'4':{price:8.99},'6':{price:12.99} }
  },
  rec_multisurfaces: {
    name:'Sachets Recharges Multi-surfaces', handle:'sachets-recharges-multi-surfaces',
    id:'', price:4.68, compareAt:5.51, category:'Maison',
    img:'', frequencies:['3m','6m','12m'],
    variants:{ '2':'52541983523148','4':'52541983555916','6':'52541983588684' },
    variantPrices:{ '2':{price:4.68},'4':{price:8.99},'6':{price:12.99} }
  },
  rec_oxis: {
    name:'Refill Oxi Clean', handle:'oxi-clean-booster-de-lavage',
    id:'9381534171468', price:10.20, compareAt:12.00, category:'Lessive',
    img:'', frequencies:['30d','60d','90d','120d'],
    variants:{ 'Default':'49249772896588' }
  },
  rec_oxiwhite: {
    name:'Refill Oxi White', handle:'oxi-white-booster-de-lavage-blanchissant',
    id:'9384463401292', price:10.20, compareAt:12.00, category:'Lessive',
    img:'', frequencies:['30d','60d','90d','120d'],
    variants:{ 'Default':'49265049239884' }
  },
  acide: {
    name:'Acide Citrique', handle:'acide-citrique-nettoyant-multi-usage',
    id:'8852140851532', price:10.20, compareAt:12.00, category:'Maison',
    img:'', frequencies:['30d','60d','90d'],
    variants:{ 'Default':'47663432761676' }
  },
  rec_acide: {
    name:'Refill Acide Citrique', handle:'refill-acide-citrique-nettoyant-multi-usage-copie',
    id:'9384496136524', price:10.20, compareAt:12.00, category:'Maison',
    img:'', frequencies:['30d','60d','90d'],
    variants:{ 'Default':'49265504321868' }
  },
  terres: {
    name:'Terres de Sommières', handle:'terres-de-sommieres',
    id:'9088166822220', price:10.20, compareAt:12.00, category:'Maison',
    img:'', frequencies:[], otp:true,
    variants:{ 'Default':'48286851596620' }
  },
};

const FREQ_LABELS = {
  '30d':'Tous les mois','60d':'Tous les 2 mois','90d':'Tous les 3 mois','120d':'Tous les 4 mois',
  '3m':'Tous les 3 mois','4m':'Tous les 4 mois','6m':'Tous les 6 mois','8m':'Tous les 8 mois',
  '9m':'Tous les 9 mois','10m':'Tous les 10 mois','12m':'Tous les 12 mois','18m':'Tous les 18 mois',
  '180d':'Tous les 6 mois','365d':'Tous les 12 mois','otp':'Achat unique'
};

const quizType='hom';
let mode='landing_hom', currentStep=0, answers={}, flow=[], resultItems=[];
const selectedFragrances={};

const Q = {
  P1:{ id:'P1', q:'Combien de personnes vivent chez vous ?', sub:'Pour calculer votre consommation', type:'radio',
    opts:[{v:'1-2',e:'👫',l:'1-2 personnes'},{v:'3-4',e:'👨‍👩‍👧',l:'3-4 personnes'},{v:'5+',e:'👨‍👩‍👧‍👦',l:'5+ personnes'}]},
  P2:{ id:'P2', q:'Y a-t-il quelque chose de particulier chez vous ?', sub:"Sélectionnez tout ce qui s'applique", type:'checkbox',
    opts:[
      {v:'peques',   e:'👶',l:'Enfants à la maison',     d:"Besoin d'un nettoyage plus doux et efficace"},
      {v:'mascota',  e:'🐾',l:'Animal(aux) de compagnie', d:'Poils, taches et odeurs en plus'},
      {v:'actividad',e:'🏃',l:'Vie active / sport',       d:'Vêtements avec des taches difficiles'},
      {v:'casa_grande',e:'🏡',l:'Grande maison (+100m²)', d:'Plus de surface à nettoyer'},
      {v:'nada',     e:'✨',l:'Rien de particulier'}
    ]},
  P2_MASCOTA:{ id:'P2_MASCOTA', q:'Quel animal avez-vous ?', sub:'', type:'radio',
    opts:[{v:'perro',e:'🐶',l:'Chien'},{v:'gato',e:'🐱',l:'Chat'},{v:'ambos',e:'🐶🐱',l:'Les deux'}]},
  P2_ARENA:{ id:'P2_ARENA', q:'À quelle fréquence changez-vous la litière ?', sub:'', type:'radio',
    opts:[{v:'diario',e:'📅',l:'Chaque jour'},{v:'2-3dias',e:'📆',l:'Tous les 2-3 jours'},{v:'semanal',e:'🗓️',l:'1x par semaine'},{v:'no_arena',e:'🌿',l:"Je n'utilise pas de litière"}]},
  P3:{ id:'P3', q:'Aimez-vous sentir votre linge ?', sub:'Intensité des Perles Parfumées', type:'radio',
    opts:[{v:'+++',e:'🌸🌸🌸',l:'Très intense',d:'30g/lavage'},{v:'++',e:'🌸🌸',l:'Intense',d:'20g/lavage'},{v:'+',e:'🌸',l:'Douce',d:'10g/lavage'},{v:'sin',e:'🍃',l:'Sans parfum'}]},
  P4:{ id:'P4', q:'Combien de lessives faites-vous par semaine ?', sub:'Toutes les lessives de votre foyer', type:'stepper', min:1, max:14, def:4, unit:'lessives/semaine' },
  P5:{ id:'P5', q:'Avez-vous un lave-vaisselle ?', sub:'', type:'radio',
    opts:[{v:'si',e:'🫧',l:"Oui, j'ai un lave-vaisselle"},{v:'no',e:'🧽',l:'Non, je lave tout à la main'}]},
  P5a:{ id:'P5a', q:'Combien de cycles de lave-vaisselle par semaine ?', sub:'', type:'stepper', min:1, max:14, def:5, unit:'cycles/semaine' },
  P5b:{ id:'P5b', q:'Combien de fois faites-vous la vaisselle à la main par jour ?', sub:'Assiettes, verres, casseroles...', type:'stepper', min:1, max:10, def:3, unit:'fois/jour' },
  PH:{ id:'PH', q:'À quelle fréquence nettoyez-vous votre maison en profondeur ?', sub:'Sols, surfaces, salles de bain...', type:'radio',
    opts:[{v:'diario',e:'🏠',l:'Tous les jours'},{v:'3x_sem',e:'🧹',l:'2-3 fois par semaine'},{v:'1x_sem',e:'✨',l:'1 fois par semaine'}]},
  EMAIL:{ id:'EMAIL', q:'Voulez-vous que nous sauvegardions votre routine ?', sub:"Votre email est protégé. C'est 100% facultatif.", type:'email' }
};

// ── DYNAMIC DATA FETCHING ──
function _fetchProductData() {
  const promises = [];
  let fetched=0, failed=0, plansFetched=0;
  Object.keys(PRODUCTS).forEach(function(key) {
    const prod = PRODUCTS[key];
    if (!prod.handle) return;
    const p = fetch('/products/'+prod.handle+'.js')
      .then(r=>{ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
      .then(data=>{
        if(data.title) prod.name=data.title;
        if(data.featured_image) prod.img=data.featured_image+'&width=400';
        prod.available=!!data.available;
        if(data.variants&&data.variants.length>0){
          const nv={};
          const va={};
          data.variants.forEach(v=>{ nv[v.title||'Default']=String(v.id); va[v.title||'Default']=!!v.available; });
          prod.variants=nv;
          prod.variantAvail=va;
          const fv=data.variants[0];
          if(fv.price) prod.price=fv.price/100;
          if(fv.compare_at_price) prod.compareAt=fv.compare_at_price/100;
          if(fv.selling_plan_allocations&&fv.selling_plan_allocations.length>0){
            const spa=fv.selling_plan_allocations[0];
            if(spa.per_delivery_price!=null) prod.subPrice=parseFloat(spa.per_delivery_price)/100;
            if(data.variants.length>1){
              prod.variantSubPrices={};
              data.variants.forEach(vv=>{
                if(vv.selling_plan_allocations&&vv.selling_plan_allocations.length>0)
                  prod.variantSubPrices[vv.title||'Default']=parseFloat(vv.selling_plan_allocations[0].per_delivery_price)/100;
              });
            }
          }
          if(data.variants.length>1){
            const vp={};
            data.variants.forEach(vv=>{
              vp[vv.title||'Default']={
                price:vv.price/100,
                compareAt:vv.compare_at_price?vv.compare_at_price/100:null,
                subPrice:(vv.selling_plan_allocations&&vv.selling_plan_allocations[0])?parseFloat(vv.selling_plan_allocations[0].per_delivery_price)/100:null
              };
            });
            prod.variantPrices=vp;
          }
        }
        if(data.id) prod.id=String(data.id);
        if(data.selling_plan_groups&&data.selling_plan_groups.length>0){
          const spMap={};
          if(data.variants&&data.variants.length>1){
            const masterBySpId={};
            data.selling_plan_groups.forEach(g=>{
              (g.selling_plans||[]).forEach(sp=>{
                let fk=null;
                (sp.options||[]).forEach(opt=>{
                  if(opt.name==='Order Frequency and Unit'&&opt.value){
                    const parts=opt.value.split('-');
                    if(parts.length===2) fk=parts[0]+(parts[1]==='day'?'d':parts[1]==='month'?'m':parts[1][0]);
                  }
                });
                if(fk&&sp.id) masterBySpId[String(sp.id)]=fk;
              });
            });
            const variantSP={};
            data.variants.forEach(vv=>{
              const vid=String(vv.id), vPlans={};
              (vv.selling_plan_allocations||[]).forEach(spa=>{
                const fk=masterBySpId[String(spa.selling_plan_id)];
                if(fk) vPlans[fk]=String(spa.selling_plan_id);
              });
              if(Object.keys(vPlans).length>0) variantSP[vid]=vPlans;
            });
            if(Object.keys(variantSP).length>0){ SELLING_PLANS[key]=variantSP; SELLING_PLANS[key]._multiVariant=true; plansFetched++; }
          } else {
            data.selling_plan_groups.forEach(g=>{
              (g.selling_plans||[]).forEach(sp=>{
                let fk=null;
                (sp.options||[]).forEach(opt=>{
                  if(opt.name==='Order Frequency and Unit'&&opt.value){
                    const parts=opt.value.split('-');
                    if(parts.length===2) fk=parts[0]+(parts[1]==='day'?'d':parts[1]==='month'?'m':parts[1][0]);
                  }
                });
                if(fk&&sp.id) spMap[fk]=String(sp.id);
              });
            });
            if(Object.keys(spMap).length>0){ SELLING_PLANS[key]=spMap; plansFetched++; }
          }
        }
        fetched++;
      })
      .catch(err=>{ failed++; dbg('AJAX fail '+key+': '+err.message); });
    promises.push(p);
  });
  return Promise.all(promises).then(()=>{ dbg('FR Quiz: '+fetched+' ok, '+failed+' failed, '+plansFetched+' with plans'); });
}

// ── QUIZ ID + SESSION ──
let _quizId='', _quizSessionId='', _quizSessionNumber=0;
function _initQuizIds(){
  try{
    _quizId=localStorage.getItem('ntl_fr_quiz_id')||'';
    if(!_quizId){ _quizId='ntlfr_'+Math.random().toString(36).substr(2,9); localStorage.setItem('ntl_fr_quiz_id',_quizId); }
    _quizSessionNumber=parseInt(localStorage.getItem('ntl_fr_quiz_session_n')||'0')+1;
    localStorage.setItem('ntl_fr_quiz_session_n',String(_quizSessionNumber));
    _quizSessionId=_quizId+'_'+_quizSessionNumber;
  } catch(e){}
}

const QUIZ_LOG_WEBHOOK=''; // À configurer pour le suivi FR
let _quizStartTime=0, _quizCompleted=false;

function _logToSheet(productRows){
  if(!QUIZ_LOG_WEBHOOK) return;
  var _quizMode='general', _entryPDP='';
  try{ var sectionEl=document.querySelector('[data-quiz-product]'); if(sectionEl){_quizMode='pdp';_entryPDP=sectionEl.getAttribute('data-quiz-product')||'';} else if(window.__quizProduct){_quizMode='pdp';_entryPDP=window.__quizProduct;} }catch(e){}
  var _entryPoint='direct';
  try{ var ref=document.referrer||''; var params=new URLSearchParams(window.location.search); if(params.get('utm_medium')==='email')_entryPoint='email'; else if(params.get('utm_medium')==='cpc'||params.get('gclid'))_entryPoint='ad'; else if(ref.includes('/products/'))_entryPoint='pdp'; else if(ref.includes('/collections/'))_entryPoint='collection'; }catch(e){}
  var _device=(window.innerWidth<768)?'mobile':'desktop';
  const baseData={ quiz_id:_quizId, quiz_session_id:_quizSessionId, quiz_session_number:_quizSessionNumber, email:answers.EMAIL||'', source:'web', country:'FR', quiz_type:quizType, quiz_mode:_quizMode, entry_pdp:_entryPDP, entry_point:_entryPoint, device:_device, household:answers.P1||'', has_kids:(answers.P2||[]).includes('peques'), has_pet:(answers.P2||[]).includes('mascota'), active_lifestyle:(answers.P2||[]).includes('actividad'), large_home:(answers.P2||[]).includes('casa_grande'), fragrance:answers.P3||'', washes_per_week:parseInt(answers.P4)||0, has_dishwasher:answers.P5==='si', dishwasher_cycles:parseInt(answers.P5a)||0, hand_washes_day:parseInt(answers.P5b)||0, cleaning_freq:answers.PH||'', quiz_status:'success', error_detail:'' };
  const rows=productRows.map(p=>Object.assign({},baseData,p));
  try{ fetch(QUIZ_LOG_WEBHOOK,{method:'POST',mode:'no-cors',headers:{'Content-Type':'application/json'},body:JSON.stringify({rows:rows})}); }catch(e){}
}

// ── KLAVIYO ──
// ── CONSENTEMENT MARKETING (RGPD) — case optionnelle, décochée par défaut ──
var _marketingConsent=false;
var _consentSubscribed=false;
var KLAVIYO_PUBLIC_KEY='S6arYg';
var KLAVIYO_QUIZ_LIST_ID='QUgnpA'; // «Welcome - Quiz FR»
function _isValidEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v||'').trim()); }
function emailInputFn(el){
  answers.EMAIL=el.value;
  var w=getEl('quizConsentWrap');
  if(w) w.style.display=_isValidEmail(el.value)?'flex':'none';
}
function consentChangeFn(el){ _marketingConsent=!!el.checked; }
function _klavSubscribeConsent(){
  if(_consentSubscribed||!_marketingConsent||!_isValidEmail(answers.EMAIL)) return;
  _consentSubscribed=true;
  try{
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_PUBLIC_KEY,{
      method:'POST',
      headers:{'Content-Type':'application/json','revision':'2024-10-15'},
      body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Quiz FR',profile:{data:{type:'profile',attributes:{email:(answers.EMAIL||'').trim()}}}},relationships:{list:{data:{type:'list',id:KLAVIYO_QUIZ_LIST_ID}}}}})
    }).catch(function(){});
  }catch(e){}
}
function _klavIdentify(props){
  try{ const kl=window.klaviyo; if(!kl)return; if(answers.EMAIL) props.email=answers.EMAIL; props['$source']='Quiz Web FR'; kl.identify(props); }catch(e){}
}
function _klavTrack(event,props){
  try{ const kl=window.klaviyo; if(!kl)return; kl.track(event,props||{}); }catch(e){}
}
function _klavBuildProfile(){
  const p2=answers.P2||[];
  return {
    'Quiz > Canal':'web',
    'Quiz > Personnes à la maison':answers.P1||'',
    'Quiz > A des enfants':p2.includes('peques'),
    'Quiz > A un animal':p2.includes('mascota'),
    'Quiz > Vie active / sport':p2.includes('actividad'),
    'Quiz > Grande maison (+100m²)':p2.includes('casa_grande'),
    'Quiz > Préférence de parfum':answers.P3||'',
    'Quiz > Lavages par semaine':parseInt(answers.P4)||0,
    'Quiz > A un lave-vaisselle':answers.P5==='si',
    'Quiz > Cycles lave-vaisselle par semaine':parseInt(answers.P5a)||0,
    'Quiz > Lavages à la main par jour':parseInt(answers.P5b)||0,
    'Quiz > Fréquence nettoyage maison':answers.PH||'',
    'Quiz > Type d\'animal':answers.P2b||''
  };
}

// ── FLOWS ──
const HOM_FLOW=['P1','P2','P3','P4','P5','PH','EMAIL','RESULTS'];
const FLOWS={
  landing_hom:HOM_FLOW,
  pdp_detergente:HOM_FLOW, pdp_oxis:HOM_FLOW, pdp_perles:HOM_FLOW,
  pdp_rec_perles:HOM_FLOW, pdp_pastillas:HOM_FLOW, pdp_lavmano:HOM_FLOW,
  pdp_lavmanopoudre:HOM_FLOW, pdp_friegasuelos:HOM_FLOW, pdp_flisflis:HOM_FLOW,
  pdp_antical:HOM_FLOW, pdp_degraissant:HOM_FLOW, pdp_vitres:HOM_FLOW,
  pdp_multisurfaces:HOM_FLOW, pdp_detachant:HOM_FLOW, pdp_acide:HOM_FLOW,
  pdp_rec_antical:HOM_FLOW, pdp_rec_multisurfaces:HOM_FLOW,
  pdp_rec_oxis:HOM_FLOW, pdp_rec_oxiwhite:HOM_FLOW, pdp_rec_acide:HOM_FLOW,
};

// ══════════════════════════════════════════
// FREQUENCY UTILS
// ══════════════════════════════════════════

function freqToDays(f){
  if(!f||f==='otp'||f==='Achat unique') return 9999;
  const clean=(typeof f==='string'?f:'').replace(/\s*·.*$/,'').trim();
  if(clean==='Tous les mois') return 30;
  const m=clean.match(/Tous les (\d+) mois/); if(m) return parseInt(m[1])*30;
  if(clean.endsWith('d')) return parseInt(clean);
  if(clean.endsWith('m')) return parseInt(clean)*30;
  const m2=clean.match(/(\d+)/); return m2?parseInt(m2[1])*30:9999;
}

function snapToFrequency(rawDays,productKey){
  const prod=PRODUCTS[productKey];
  if(!prod||prod.otp) return {freq:'otp',label:'Achat unique',qty:1};
  const freqs=prod.frequencies;
  if(!freqs||freqs.length===0) return {freq:'otp',label:'Achat unique',qty:1};
  if(freqs.length===1) return {freq:freqs[0],label:FREQ_LABELS[freqs[0]],qty:1};
  const toDays=f=>f.endsWith('d')?parseInt(f):f.endsWith('m')?parseInt(f)*30:30;
  const fd=freqs.map(f=>({freq:f,days:toDays(f)})).sort((a,b)=>a.days-b.days);
  if(rawDays>=fd[fd.length-1].days*0.8) return {freq:fd[fd.length-1].freq,label:FREQ_LABELS[fd[fd.length-1].freq],qty:1};
  for(let i=fd.length-1;i>=0;i--){ if(rawDays>=fd[i].days*0.75) return {freq:fd[i].freq,label:FREQ_LABELS[fd[i].freq],qty:1}; }
  return {freq:fd[0].freq,label:FREQ_LABELS[fd[0].freq],qty:1};
}

// ══════════════════════════════════════════
// CALC FUNCTIONS
// ══════════════════════════════════════════

function calcDet40(lavSem){ return snapToFrequency((40/lavSem)*7,'det40'); }
function calcDet360(lavSem){
  if(lavSem>=8) return {freq:'10m',label:FREQ_LABELS['10m'],qty:1};
  if(lavSem>=5) return {freq:'12m',label:FREQ_LABELS['12m'],qty:1};
  return {freq:'18m',label:FREQ_LABELS['18m'],qty:1};
}
function calcOxis(lavSem){ return snapToFrequency((500/15/lavSem)*7,'oxis'); }
function calcPerles(lavSem,intens){
  const g=intens==='+++'?30:intens==='++'?20:10;
  return snapToFrequency((300/g/lavSem)*7,'perles');
}
function calcPastillas(ciclosSem){ return snapToFrequency((60/ciclosSem)*7,'pastillas'); }
function calcLavMano(lavDia){
  const meses=(250/lavDia)/30;
  const intervals=[3,6,12];
  const freqM=intervals.find(m=>m>=meses)||12;
  return {freq:freqM+'m',label:FREQ_LABELS[freqM+'m'],qty:1};
}
function calcFriegasuelos(freq,grande){
  const fregados=grande?15:30;
  const fregSem=freq==='diario'?3:freq==='3x_sem'?2:1;
  const dias=(fregados/fregSem)*7;
  if(dias>=270) return {freq:'12m',label:FREQ_LABELS['12m'],qty:1};
  if(dias>=135) return {freq:'6m',label:FREQ_LABELS['6m'],qty:1};
  return {freq:'3m',label:FREQ_LABELS['3m'],qty:1};
}
function calcFlisFlis(freq,grande){
  const map={diario:{n:'3m',g:'6m'},'3x_sem':{n:'6m',g:'12m'},'1x_sem':{n:'12m',g:'12m'}};
  const f=map[freq]||map['3x_sem'];
  const chosen=grande?f.g:f.n;
  const variant=grande?'4 de chaque':'2 de chaque';
  return {freq:chosen,label:FREQ_LABELS[chosen],qty:1,variant};
}
function calcIndividualHogar(freq,grande){
  const map={diario:{n:'3m',g:'6m'},'3x_sem':{n:'6m',g:'12m'},'1x_sem':{n:'12m',g:'12m'}};
  const f=map[freq]||map['3x_sem'];
  const chosen=grande?f.g:f.n;
  return {freq:chosen,label:FREQ_LABELS[chosen],qty:1,variant:grande?'4':'2'};
}
function calcDetachant(peques,mascota){
  if(peques||mascota) return {freq:'8m',label:FREQ_LABELS['8m'],qty:1};
  return {freq:'12m',label:FREQ_LABELS['12m'],qty:1};
}
function calcAcide(){ return snapToFrequency(90,'acide'); }

function computeRawDays(item){
  const lavSem=answers.P4||4, frag=answers.P3||'++';
  const frecH=answers.PH||answers.KH||'3x_sem';
  const p2=answers.P2||[];
  const casaGrande=p2.includes('casa_grande'), peques=p2.includes('peques'), mascota=p2.includes('mascota');
  switch(item.key){
    case 'det40': return (40/lavSem)*7;
    case 'det360': return lavSem>=8?300:lavSem>=5?360:540;
    case 'perles': case 'rec_perles':{ const g=frag==='+++'?30:frag==='++'?20:10; return (300/g/lavSem)*7; }
    case 'oxis': case 'rec_oxis': return (500/15/lavSem)*7;
    case 'rec_oxiwhite': return (500/15/lavSem)*7;
    case 'detachant': return (peques||mascota)?240:360;
    case 'pastillas': return (60/(answers.P5a||5))*7;
    case 'lavmano': case 'lavmanopoudre': return 250/(answers.P5b||3);
    case 'friegasuelos':{ const fr=casaGrande?15:30; const fs=frecH==='diario'?3:frecH==='3x_sem'?2:1; return (fr/fs)*7; }
    case 'flisflis': case 'antical': case 'degraissant': case 'vitres': case 'multisurfaces':
    case 'rec_antical': case 'rec_multisurfaces':{ const mp={diario:{n:90,g:180},'3x_sem':{n:180,g:360},'1x_sem':{n:360,g:360}}; const mf=mp[frecH]||mp['3x_sem']; return casaGrande?mf.g:mf.n; }
    case 'acide': case 'rec_acide': return 90;
    default: return null;
  }
}

const STAR_PRIORITY={
  det40:100,
  pastillas:50,friegasuelos:40,perles:30,lavmano:20,flisflis:10,
  antical:9,degraissant:9,vitres:9,multisurfaces:9,
  oxis:8,rec_antical:7,rec_multisurfaces:7,rec_perles:7,
  rec_oxiwhite:4,rec_oxis:4,detachant:6,det360:5,
  rec_acide:3,lavmanopoudre:7,acide:2,terres:1
};

function assignShipments(items){
  const sub=items.filter(i=>i.rawDays&&!PRODUCTS[i.key]?.otp);
  sub.forEach(item=>{ item.shipmentGroup=freqToDays(item.freq); });
}

// ══════════════════════════════════════════
// QUIZ ENGINE
// ══════════════════════════════════════════

function getEl(id){ return document.getElementById(id); }
function dbg(msg){ if(typeof console!=='undefined') console.log('[NTL Quiz FR]',msg); }


function startQuiz(selectedMode){
  mode=selectedMode||'landing_hom';
  answers={}; currentStep=0; _quizCompleted=false; _quizStartTime=Date.now();
  flow=[...(FLOWS[mode]||FLOWS.landing_hom)];
  _initQuizIds(); _fetchProductData();
  _klavIdentify({'Quiz > Canal':'web','Quiz > Type de quiz':quizType});
  _klavTrack('Quiz Démarré',{quiz_type:quizType,source:'web',country:'FR'});
  _logToSheet([{action_type:'quiz_started'}]);
  var overlay=getEl('quizOverlay');
  if(overlay){
    overlay.classList.add('active');
    if(typeof overlay.showModal==='function' && !overlay.open){ overlay.showModal(); }
  }
  document.body.style.overflow='hidden';
  renderStep();
}

function closeQuiz(){
  if(!_quizCompleted&&_quizStartTime>0){
    var duration=Math.round((Date.now()-_quizStartTime)/1000);
    var stepId=flow&&flow[currentStep]?flow[currentStep]:'unknown';
    _klavIdentify({'Quiz > Abandonné sans finir':true,'Quiz > Dernière étape avant abandon':stepId});
    _klavTrack('Quiz Abandonné',{quiz_type:quizType,source:'web',country:'FR',last_step:stepId,steps_completed:currentStep,duration:duration});
    if(QUIZ_LOG_WEBHOOK){
      try{
        navigator.sendBeacon(QUIZ_LOG_WEBHOOK,JSON.stringify({rows:[{
          quiz_id:_quizId,quiz_session_id:_quizSessionId,source:'web',country:'FR',quiz_type:quizType,
          action_type:'quiz_abandoned',last_step:stepId,steps_completed:currentStep,quiz_duration:duration,
          household:answers.P1||'',has_kids:(answers.P2||[]).includes('peques'),
          has_pet:(answers.P2||[]).includes('mascota'),quiz_status:'success',error_detail:''
        }]}));
      }catch(e){}
    }
  }
  var overlay=getEl('quizOverlay');
  if(overlay){
    overlay.classList.remove('active');
    if(typeof overlay.close==='function' && overlay.open){ overlay.close(); }
  }
  document.body.style.overflow='';
  saveState();
}

function resetQuiz(){ answers={}; currentStep=0; sessionStorage.removeItem('nq_fr_state'); closeQuiz(); }

function getActiveFlow(){
  var result=[];
  for(var i=0;i<(FLOWS[mode]||[]).length;i++){
    var s=(FLOWS[mode]||[])[i];
    result.push(s);
    if(s==='P2'){
      var p2=answers.P2||[];
      if(p2.includes('mascota')){ result.push('P2_MASCOTA'); if(['gato','ambos'].includes(answers.P2_MASCOTA)) result.push('P2_ARENA'); }
    }
    if(s==='P5'){ if(answers.P5==='si') result.push('P5a'); result.push('P5b'); }
  }
  return result;
}

function renderStep(){
  flow=getActiveFlow();
  var stepId=flow[currentStep];
  if(!stepId) return;
  var pct=((currentStep+1)/flow.length)*100;
  var bar=getEl('progressBar'); if(bar) bar.style.width=pct+'%';
  var backBtn=getEl('backBtn');
  if(backBtn){ backBtn.style.display=currentStep>0?'':'none'; backBtn.onclick=goBack; }
  var nextBtn=getEl('nextBtn'), body=getEl('quizBody'), footer=getEl('quizFooter');
  if(stepId==='RESULTS'){
    if(footer) footer.style.display='none';
    if(body){ body.innerHTML=''; renderResults(body); }
    pushKlaviyo('completed');
    return;
  }
  if(footer) footer.style.display='';
  var q=Q[stepId]; if(!q){ goNext(); return; }
  var html='<div class="quiz-step active">';
  html+='<div class="quiz-question">'+q.q+'</div>';
  if(q.sub) html+='<div class="quiz-subtitle">'+q.sub+'</div>';
  if(q.type==='radio'){
    html+='<div class="quiz-options">';
    q.opts.forEach(function(o){
      var sel=answers[stepId]===o.v?' selected':'';
      html+='<div class="quiz-option'+sel+'" data-value="'+o.v+'" onclick="window._ntlQuizFR.pickRadio(this,\''+stepId+'\',\''+o.v+'\')">';
      html+='<span class="quiz-option-indicator"></span>';
      if(o.e) html+='<span class="quiz-option-emoji">'+o.e+'</span>';
      html+='<span class="quiz-option-text"><span class="quiz-option-label">'+o.l+'</span>';
      if(o.d) html+='<div class="quiz-option-desc">'+o.d+'</div>';
      html+='</span></div>';
    });
    html+='</div>';
    if(nextBtn) nextBtn.disabled=!answers[stepId];
  } else if(q.type==='checkbox'){
    var cur=answers[stepId]||[];
    html+='<div class="quiz-options">';
    q.opts.forEach(function(o){
      var sel=cur.includes(o.v)?' selected':'';
      html+='<div class="quiz-option checkbox'+sel+'" data-value="'+o.v+'" onclick="window._ntlQuizFR.pickCheck(this,\''+stepId+'\',\''+o.v+'\')">';
      html+='<span class="quiz-option-indicator"></span>';
      if(o.e) html+='<span class="quiz-option-emoji">'+o.e+'</span>';
      html+='<span class="quiz-option-text"><span class="quiz-option-label">'+o.l+'</span>';
      if(o.d) html+='<div class="quiz-option-desc">'+o.d+'</div>';
      html+='</span></div>';
    });
    html+='</div>';
    if(nextBtn) nextBtn.disabled=cur.length===0;
  } else if(q.type==='stepper'){
    var val=answers[stepId]||q.def; answers[stepId]=val;
    html+='<div class="quiz-stepper">';
    html+='<button onclick="window._ntlQuizFR.stepper(\''+stepId+'\',-1,'+q.min+','+q.max+')">−</button>';
    html+='<div><span class="stepper-value" id="sv_'+stepId+'">'+val+'</span><div class="stepper-unit">'+q.unit+'</div></div>';
    html+='<button onclick="window._ntlQuizFR.stepper(\''+stepId+'\',1,'+q.min+','+q.max+')">+</button>';
    html+='</div>';
    if(nextBtn) nextBtn.disabled=false;
  } else if(q.type==='email'){
    html+='<div class="quiz-email-wrap">';
    html+='<input type="email" class="quiz-email-input" placeholder="votre@email.com" value="'+(answers.EMAIL||'')+'" oninput="window._ntlQuizFR.emailInput(this)">';
    html+='<label class="quiz-consent" id="quizConsentWrap" style="display:'+(_isValidEmail(answers.EMAIL)?'flex':'none')+';gap:8px;align-items:flex-start;font-size:13px;margin-top:10px;text-align:left;cursor:pointer;">';
    html+='<input type="checkbox" id="quizConsent" style="margin-top:2px;flex-shrink:0;"'+(_marketingConsent?' checked':'')+' onchange="window._ntlQuizFR.consentChange(this)">';
    html+='<span>Je souhaite recevoir mes conseils d\'entretien et les offres Natulim par e-mail. Désinscription en 1 clic.</span>';
    html+='</label>';
    html+='<span class="quiz-email-skip" onclick="window._ntlQuizFR.answers.EMAIL=\'\';window._ntlQuizFR.goNext()">Pas maintenant, merci</span>';
    html+='</div>';
    if(nextBtn){ nextBtn.disabled=false; nextBtn.textContent='Voir ma routine sur mesure ✨'; }
  }
  html+='</div>';
  if(body) body.innerHTML=html;
  if(q.type!=='email'&&nextBtn) nextBtn.textContent='Suivant';
  if(nextBtn) nextBtn.onclick=goNext;
}

function pickRadio(el,sid,val){ answers[sid]=val; el.parentElement.querySelectorAll('.quiz-option').forEach(function(o){o.classList.remove('selected');}); el.classList.add('selected'); var btn=getEl('nextBtn'); if(btn) btn.disabled=false; pushKlaviyo(sid); }
function pickCheck(el,sid,val){
  if(!Array.isArray(answers[sid])) answers[sid]=[];
  if(val==='nada'){ answers[sid]=['nada']; el.parentElement.querySelectorAll('.quiz-option').forEach(function(o){o.classList.remove('selected');}); el.classList.add('selected'); }
  else{ answers[sid]=answers[sid].filter(function(v){return v!=='nada';}); var nadaEl=el.parentElement.querySelector('[data-value="nada"]'); if(nadaEl) nadaEl.classList.remove('selected'); if(answers[sid].includes(val)){answers[sid]=answers[sid].filter(function(v){return v!==val;});el.classList.remove('selected');} else{answers[sid].push(val);el.classList.add('selected');} }
  var btn=getEl('nextBtn'); if(btn) btn.disabled=answers[sid].length===0;
  pushKlaviyo(sid);
}
function stepperFn(sid,d,mn,mx){ var v=(answers[sid]||Q[sid].def)+d; v=Math.max(mn,Math.min(mx,v)); answers[sid]=v; var el=getEl('sv_'+sid); if(el) el.textContent=v; pushKlaviyo(sid); }
function goNext(){ currentStep++; renderStep(); saveState(); }
function goBack(){ if(currentStep>0){currentStep--;renderStep();saveState();} }

// ══════════════════════════════════════════
// STOCK-AWARE VARIANT SELECTION
// ══════════════════════════════════════════

// Retourne la première variante en stock d'un produit, dans l'ordre de préférence donné.
// Si `_fetchProductData` n'a pas encore résolu (variantAvail vide), on garde le comportement
// d'origine (1ère variante) plutôt que de bloquer la recommandation par manque de données.
function firstAvailableVariant(prodKey, preferredOrder){
  var prod=PRODUCTS[prodKey]; if(!prod) return null;
  var avail=prod.variantAvail||{};
  var keys=Object.keys(prod.variants||{});
  if(Object.keys(avail).length===0) return keys[0]||null;
  var order=(preferredOrder&&preferredOrder.length)?preferredOrder:keys;
  for(var i=0;i<order.length;i++){ if(avail[order[i]]) return order[i]; }
  for(var t in avail){ if(avail[t]) return t; }
  return null; // toutes les variantes sont en rupture
}

function getSubPrice(item){
  if(item.subPrice!=null) return item.subPrice;
  if(item.discount) return item.price*(1-item.discount/100);
  return item.price;
}

function buildBundle(){
  var items=[];
  var p2=answers.P2||[];
  var peques=p2.includes('peques'), mascota=p2.includes('mascota');
  var actividad=p2.includes('actividad'), casaGrande=p2.includes('casa_grande');
  var lavSem=answers.P4||4, frag=answers.P3||'++';
  var frecH=answers.PH||answers.KH||'3x_sem';
  var isPDP=mode.startsWith('pdp_');
  var pdpProd=mode.replace('pdp_','');

  // HOM-only (FR store does not carry Kēr line)
  {
    var det40f=calcDet40(lavSem), det360f=calcDet360(lavSem);
    var highConsumption=det40f.freq==='30d';
    // Détergent — si enfants: variante sans parfum avec badge bébé (stock-aware)
    if(peques){
      var detVarKids=firstAvailableVariant('det40',['Sans parfum (peau sensible & bébé)','Floral','Lavande']);
      if(detVarKids){
        items.push({key:'det40',...PRODUCTS.det40,
          name: detVarKids==='Sans parfum (peau sensible & bébé)' ? 'Éco-Feuilles Sans Parfum' : PRODUCTS.det40.name,
          freq:det40f.freq,freqLabel:det40f.label,qty:1,checked:true,
          pdpMatch:pdpProd==='detergente',
          badge: detVarKids==='Sans parfum (peau sensible & bébé)' ? '👶 Sans parfum — peau sensible & bébé' : 'En stock',
          selectedVariant:detVarKids
        });
        selectedFragrances.det40=detVarKids;
      }
      // si detVarKids===null → det40 totalement en rupture, on ne le recommande pas
    } else {
      var detVar=firstAvailableVariant('det40',['Floral','Lavande','Sans parfum (peau sensible & bébé)']);
      if(detVar){
        items.push({key:'det40',...PRODUCTS.det40,freq:det40f.freq,freqLabel:det40f.label,qty:1,checked:true,pdpMatch:pdpProd==='detergente',
          selectedVariant:detVar, badge: detVar==='Sans parfum (peau sensible & bébé)' ? 'En stock' : undefined});
        selectedFragrances.det40=detVar;
      }
      if(highConsumption){
        var det360Var=firstAvailableVariant('det360',['Floral','Lavande','Sans parfum']);
        if(det360Var){
          items.push({key:'det360',...PRODUCTS.det360,freq:det360f.freq,freqLabel:det360f.label,qty:1,checked:false,suggested:true,badge:"Option économie — grand consommateur",selectedVariant:det360Var});
          selectedFragrances.det360=det360Var;
        }
      }
    }
    // Oxi Clean
    var oxisf=calcOxis(lavSem);
    var oxisChecked=peques||mascota||actividad;
    items.push({key:'oxis',...PRODUCTS.oxis,freq:oxisf.freq,freqLabel:oxisf.label,qty:1,checked:oxisChecked,suggested:!oxisChecked,pdpMatch:pdpProd==='oxis'});
    // Perles (stock-aware)
    if(frag!=='sin'){
      var perlesf=calcPerles(lavSem,frag);
      var intLabel=frag==='+++'?'Très intense':frag==='++'?'Intense':'Douce';
      var perlesVar=firstAvailableVariant('perles',['Floral','Lavande','Aurora']);
      if(perlesVar){
        items.push({key:'perles',...PRODUCTS.perles,name:'Perles '+intLabel,freq:perlesf.freq,freqLabel:perlesf.label,qty:1,checked:true,pdpMatch:pdpProd==='perles',selectedVariant:perlesVar});
        selectedFragrances.perles=perlesVar;
      }
      // si perlesVar===null → perles totalement en rupture, on ne les recommande pas
    }
    // Détachant (remplace quitamanchas)
    var detachf=calcDetachant(peques,mascota);
    items.push({key:'detachant',...PRODUCTS.detachant,freq:detachf.freq,freqLabel:detachf.label,qty:1,checked:peques||mascota,suggested:!(peques||mascota),pdpMatch:pdpProd==='detachant'});
    // Lave-vaisselle
    var lavManoFreq=calcLavMano(answers.P5b||3);
    if(answers.P5==='si'){
      var pastf=calcPastillas(answers.P5a||5);
      items.push({key:'pastillas',...PRODUCTS.pastillas,freq:pastf.freq,freqLabel:pastf.label,qty:1,checked:true,pdpMatch:pdpProd==='pastillas'});
      items.push({key:'lavmano',...PRODUCTS.lavmano,freq:lavManoFreq.freq,freqLabel:lavManoFreq.label,qty:1,checked:false,suggested:true,pdpMatch:pdpProd==='lavmano'});
    } else {
      items.push({key:'lavmano',...PRODUCTS.lavmano,freq:lavManoFreq.freq,freqLabel:lavManoFreq.label,qty:1,checked:true,pdpMatch:pdpProd==='lavmano'});
    }
    // Friegasuelos
    var friegf=calcFriegasuelos(frecH,casaGrande);
    items.push({key:'friegasuelos',...PRODUCTS.friegasuelos,freq:friegf.freq,freqLabel:friegf.label,qty:1,checked:true,pdpMatch:pdpProd==='friegasuelos'});
    // Flis-Flis
    var flisf=calcFlisFlis(frecH,casaGrande);
    var flisVP=PRODUCTS.flisflis.variantPrices?.[flisf.variant];
    items.push({key:'flisflis',...PRODUCTS.flisflis,
      price:flisVP?flisVP.price:PRODUCTS.flisflis.price,
      compareAt:flisVP?flisVP.compareAt:PRODUCTS.flisflis.compareAt,
      freq:flisf.freq,freqLabel:flisf.label,qty:1,checked:true,
      pdpMatch:pdpProd==='flisflis',badge:flisf.variant,selectedVariant:flisf.variant
    });
    // Acide Citrique
    var acidef=calcAcide();
    items.push({key:'acide',...PRODUCTS.acide,freq:acidef.freq,freqLabel:acidef.label,qty:1,checked:false,suggested:true,pdpMatch:pdpProd==='acide'});
    // Individual hogar (pour PDPs individuels)
    var flisIndividuals=['antical','degraissant','vitres','multisurfaces'];
    var indHogar=calcIndividualHogar(frecH,casaGrande);
    flisIndividuals.forEach(function(pk){
      var isPdpHero=pdpProd===pk;
      if(isPdpHero||pdpProd==='rec_'+pk){
        var prod=PRODUCTS[pk];
        var vp=prod.variantPrices?.[indHogar.variant];
        items.push({key:pk,...prod,
          price:vp?vp.price:prod.price,compareAt:vp?vp.compareAt:prod.compareAt,
          freq:indHogar.freq,freqLabel:indHogar.label,qty:1,
          checked:true,pdpMatch:isPdpHero,
          badge:indHogar.variant+' unités',selectedVariant:indHogar.variant
        });
      }
    });
    // Recharges PDP
    var recargaMap={
      rec_antical:function(){return indHogar;},
      rec_multisurfaces:function(){return indHogar;},
      rec_perles:function(){return frag!=='sin'?calcPerles(lavSem,frag):{freq:'90d',label:FREQ_LABELS['90d'],qty:1};},
      rec_oxiwhite:function(){return calcOxis(lavSem);},
      rec_oxis:function(){return calcOxis(lavSem);},
      rec_acide:function(){return calcAcide();},
      lavmanopoudre:function(){return calcLavMano(answers.P5b||3);}
    };
    Object.keys(recargaMap).forEach(function(rk){
      if(pdpProd===rk){
        var rc=recargaMap[rk](), prod=PRODUCTS[rk]; if(!prod) return;
        var hasVP=prod.variantPrices&&Object.keys(prod.variantPrices).length>1;
        var price=prod.price, variant=null;
        if(hasVP){ variant=indHogar.variant||'2'; var vp2=prod.variantPrices[variant]; if(vp2) price=vp2.price; }
        items.push({key:rk,...prod,price:price,freq:rc.freq,freqLabel:rc.label,qty:rc.qty||1,checked:true,pdpMatch:true,badge:variant?variant+' unités':null,selectedVariant:variant});
      }
    });
    // Terres de Sommières
    if(mascota||peques){
      items.push({key:'terres',...PRODUCTS.terres,freq:'otp',freqLabel:'Achat unique',qty:1,checked:mascota,suggested:!mascota,badge:'Sans abonnement'});
    }
  }

  items.forEach(function(item){ item.rawDays=computeRawDays(item); });

  // Bundle rules
  var getPriority=function(item){ var p=STAR_PRIORITY[item.key]||0; if(item.pdpMatch) p+=1000; return p; };
  var MAX_TOTAL=8, HARD_MIN=2, SOFT_MIN=5, MAX_SELECTED=8;
  var has360=items.some(function(i){return i.key==='det360';});
  var BUDGET=has360?130:80;
  var getItemTotal=function(i){return getSubPrice(i)*i.qty;};
  items.sort(function(a,b){return getPriority(b)-getPriority(a);});
  if(items.length>MAX_TOTAL) items.length=MAX_TOTAL;
  if(items.filter(function(i){return i.checked;}).length<SOFT_MIN){
    var unchecked=items.filter(function(i){return !i.checked;}).sort(function(a,b){return getPriority(b)-getPriority(a);});
    for(var u=0;u<unchecked.length;u++){ if(items.filter(function(i){return i.checked;}).length>=SOFT_MIN) break; unchecked[u].checked=true; unchecked[u].suggested=false; }
  }
  var checkedItems=items.filter(function(i){return i.checked;});
  var runningTotal=checkedItems.reduce(function(s,i){return s+getItemTotal(i);},0);
  if(runningTotal>BUDGET){
    var byPriorityAsc=checkedItems.slice().sort(function(a,b){return getPriority(a)-getPriority(b);});
    for(var b=0;b<byPriorityAsc.length;b++){
      if(runningTotal<=BUDGET||items.filter(function(i){return i.checked;}).length<=HARD_MIN) break;
      if(byPriorityAsc[b].pdpMatch||byPriorityAsc[b].protected) continue;
      byPriorityAsc[b].checked=false; byPriorityAsc[b].suggested=true;
      runningTotal-=getItemTotal(byPriorityAsc[b]);
    }
  }
  if(runningTotal<BUDGET){
    var suggested=items.filter(function(i){return !i.checked;}).sort(function(a,b){return getPriority(b)-getPriority(a);});
    for(var s=0;s<suggested.length;s++){
      if(items.filter(function(i){return i.checked;}).length>=MAX_SELECTED) break;
      var cost=getItemTotal(suggested[s]);
      if(runningTotal+cost<=BUDGET){suggested[s].checked=true;suggested[s].suggested=false;runningTotal+=cost;}
    }
  }
  if(mode.startsWith('pdp_')){ var match=items.find(function(i){return i.pdpMatch;}); if(match) match.checked=true; }
  dbg('Bundle FR: '+items.length+' items, '+items.filter(function(i){return i.checked;}).length+' checked');
  return items;
}

// ══════════════════════════════════════════
// RENDER RESULTS
// ══════════════════════════════════════════

function buildRecurringBreakdownHTML(checkedItems){
  if(!checkedItems||checkedItems.length===0) return '';
  var subItems=[];
  checkedItems.forEach(function(i){
    if(!i.freq||i.freq==='otp') return;
    var days=freqToDays(i.freq); if(days>=9999) return;
    var freqMonths=Math.round(days/30); if(freqMonths<1) return;
    var price=i.recurringPrice?i.recurringPrice*i.qty:getSubPrice(i)*i.qty;
    var compareAt=(i.compareAt||i.price)*i.qty;
    subItems.push({name:i.name,qty:i.qty,price:price,compareAt:compareAt,freqMonths:freqMonths});
  });
  if(subItems.length===0) return '';
  var NUM_SHIPMENTS=4, shipments=[];
  for(var month=1;month<=36&&shipments.length<NUM_SHIPMENTS;month++){
    var due=[]; subItems.forEach(function(item){if(month%item.freqMonths===0) due.push(item);});
    if(due.length>0){ var total=due.reduce(function(s,i){return s+i.price;},0); var totalCompare=due.reduce(function(s,i){return s+i.compareAt;},0); shipments.push({month:month,items:due,total:total,totalCompare:totalCompare}); }
  }
  if(shipments.length===0) return '';
  var next=shipments[0];
  var html='<div class="recurring-breakdown" id="recurBreakdown">';
  html+='<div class="rb-toggle" onclick="document.getElementById(\'recurBreakdown\').classList.toggle(\'open\')">';
  html+='<span class="rb-arrow">▸</span>';
  html+='<span class="rb-label">Vos '+shipments.length+' prochains envois</span>';
  html+='<span class="rb-price"><span class="st-compare">'+next.totalCompare.toFixed(2)+'€</span> '+next.total.toFixed(2)+'€</span>';
  html+='</div><div class="rb-details">';
  shipments.forEach(function(shipment){
    html+='<div class="rb-group"><div class="rb-group-header">';
    html+='<span class="rb-connector">📦</span>';
    html+='<span class="rb-group-freq">Mois '+shipment.month+'</span>';
    html+='<span class="rb-group-total"><span class="st-compare" style="font-size:11px">'+shipment.totalCompare.toFixed(2)+'€</span> '+shipment.total.toFixed(2)+'€</span>';
    html+='</div>';
    shipment.items.forEach(function(item){
      html+='<div class="rb-group-item"><span class="rb-item-name">'+item.name+(item.qty>1?' ×'+item.qty:'')+'</span>';
      html+='<span class="rb-item-price">'+item.price.toFixed(2)+'€</span></div>';
    });
    html+='</div>';
  });
  html+='</div></div>';
  return html;
}

function renderProductCard(item){
  var checkedCls=item.checked?' checked':'', suggestedCls=item.suggested?' suggested':'';
  var prod=PRODUCTS[item.key], imgSrc=item.img||'';
  if(prod&&prod.variantImages){
    var frag=selectedFragrances[item.key]||Object.keys(prod.variants||{})[0];
    if(frag&&prod.variantImages[frag]) imgSrc=prod.variantImages[frag];
  }
  var subPrice=getSubPrice(item), compareAt=item.compareAt, recPrice=item.recurringPrice;
  var priceHTML;
  if(recPrice){
    var initialTotal=(subPrice*item.qty).toFixed(2), recurTotal=(recPrice*item.qty).toFixed(2);
    priceHTML='<div class="pc-price-dual"><div class="pc-price-initial"><span class="pc-price-tag">1er envoi</span>';
    if(compareAt) priceHTML+='<span class="pc-compare">'+(compareAt*item.qty).toFixed(2)+'€</span>';
    priceHTML+='<span class="pc-sub-price">'+initialTotal+'€</span></div>';
    priceHTML+='<div class="pc-price-recurring"><span class="pc-price-tag recur">Recharges suivantes</span>';
    priceHTML+='<span class="pc-sub-price recur">'+recurTotal+'€</span></div></div>';
  } else {
    var strikePrice=compareAt||(item.discount?item.price:null);
    var hasDiscount=strikePrice&&strikePrice>subPrice;
    var savingsPercent=hasDiscount?Math.round((1-subPrice/strikePrice)*100):0;
    priceHTML=hasDiscount
      ?'<span class="pc-compare">'+(strikePrice*item.qty).toFixed(2)+'€</span><span class="pc-sub-price">'+(subPrice*item.qty).toFixed(2)+'€</span><span class="pc-savings-label">Économisez '+savingsPercent+'%</span>'
      :'<span class="pc-sub-price">'+(subPrice*item.qty).toFixed(2)+'€</span>';
  }
  var fragHTML='';
  if(prod&&prod.hasFragrance&&prod.variants){
    var fragOptions=Object.keys(prod.variants), defaultFrag=selectedFragrances[item.key]||fragOptions[0];
    fragHTML='<div class="pc-fragrance" onclick="event.stopPropagation()"><span class="pc-frag-label">Choisissez votre parfum :</span><div class="pc-frag-pills">';
    fragOptions.forEach(function(f){
      var active=f===defaultFrag?' active':'';
      var oos=prod.variantAvail&&prod.variantAvail[f]===false;
      if(oos){
        fragHTML+='<span class="pc-frag-opt oos" data-key="'+item.key+'" data-frag="'+f+'" aria-disabled="true" title="Rupture de stock">'+f+' <small>(rupture)</small></span>';
      } else {
        fragHTML+='<span class="pc-frag-opt'+active+'" data-key="'+item.key+'" data-frag="'+f+'" onclick="window._ntlQuizFR.selectFragrance(\''+item.key+'\',\''+f+'\',this)">'+f+'</span>';
      }
    });
    fragHTML+='</div></div>';
  }
  return '<div class="product-card'+checkedCls+suggestedCls+'" id="pc_'+item.key+'" onclick="window._ntlQuizFR.toggleCard(\''+item.key+'\')">'+
    '<div class="pc-top"><div class="pc-check"></div><span class="pc-name">'+item.name+'</span>'+
    '<div class="pc-stepper" onclick="event.stopPropagation()"><button onclick="window._ntlQuizFR.chgQty(\''+item.key+'\',-1)">−</button>'+
    '<span class="qty" id="qty_'+item.key+'">'+item.qty+'</span>'+
    '<button onclick="window._ntlQuizFR.chgQty(\''+item.key+'\',1)">+</button></div></div>'+
    '<div class="pc-body"><div class="pc-img" id="img_'+item.key+'">'+
    (imgSrc?'<img src="'+imgSrc+'" alt="'+item.name+'" onerror="this.parentElement.textContent=\'📦\'">':'📦')+
    '</div><div class="pc-details"><div class="pc-freq">'+item.freqLabel+'</div>'+fragHTML+
    '<div class="pc-price">'+priceHTML+'</div>'+
    (item.badge?'<div class="pc-badge">'+item.badge+'</div>':'')+
    '</div></div></div>';
}

function renderResults(container){
  var items=buildBundle(); resultItems=items;
  var isPDP=mode.startsWith('pdp_'), pdpProduct=isPDP?mode.replace('pdp_',''):null;
  if(!isPDP) assignShipments(items);
  var html='';
  // Benefits strip
  html+='<div class="subs-benefits"><div class="subs-benefit"><span class="sb-icon">🚫</span>Sans engagement</div><div class="subs-benefit"><span class="sb-icon">📦</span>Livraison offerte</div><div class="subs-benefit"><span class="sb-icon">⏸️</span>Pause à tout moment</div><div class="subs-benefit"><span class="sb-icon">💰</span>Jusqu\'à -25%</div></div>';
  // Header
  html+='<div class="results-header"><div class="caas-badge">Votre routine ménage</div>';
  // PDP Hero
  if(isPDP&&pdpProduct){
    var heroItem=items.find(function(i){return i.key===pdpProduct||i.pdpMatch;});
    if(heroItem){
      var heroSub=getSubPrice(heroItem)*heroItem.qty, heroCompare=(heroItem.compareAt||heroItem.price)*heroItem.qty;
      var heroRecurring=heroItem.recurringPrice, heroProd=PRODUCTS[heroItem.key];
      var heroFragHTML='', heroImgSrc=heroItem.img||'';
      if(heroProd&&heroProd.hasFragrance&&heroProd.variants){
        var fragOpts=Object.keys(heroProd.variants), defaultFrag=selectedFragrances[heroItem.key]||fragOpts[0];
        if(heroProd.variantImages&&heroProd.variantImages[defaultFrag]) heroImgSrc=heroProd.variantImages[defaultFrag];
        heroFragHTML='<div class="pc-fragrance" style="margin-top:8px"><span class="pc-frag-label">Choisissez votre parfum :</span><div class="pc-frag-pills">';
        fragOpts.forEach(function(f){
          var act=f===defaultFrag?' active':'';
          var oos=heroProd.variantAvail&&heroProd.variantAvail[f]===false;
          if(oos){ heroFragHTML+='<span class="pc-frag-opt oos" aria-disabled="true" title="Rupture de stock">'+f+' <small>(rupture)</small></span>'; }
          else { heroFragHTML+='<span class="pc-frag-opt'+act+'" onclick="window._ntlQuizFR.selectFragrance(\''+heroItem.key+'\',\''+f+'\',this)">'+f+'</span>'; }
        });
        heroFragHTML+='</div></div>';
      }
      html+='<div class="result-hero"><div class="rh-label">Votre fréquence idéale</div><div class="rh-freq">'+heroItem.freqLabel+'</div>';
      html+='<div class="rh-product-card"><div class="rh-product-img">'+(heroImgSrc?'<img src="'+heroImgSrc+'" alt="'+heroItem.name+'">':'📦')+'</div>';
      html+='<div class="rh-product-details"><div class="rh-product-name">'+heroItem.name+'</div>'+heroFragHTML;
      html+='<div class="rh-product-price">';
      if(heroRecurring){
        html+='<div class="rh-price-dual"><div class="rh-price-row"><span class="rh-price-tag">1er envoi</span>';
        if(heroCompare>heroSub) html+='<span class="compare">'+heroCompare.toFixed(2)+'€</span>';
        html+='<span class="sub-price">'+heroSub.toFixed(2)+'€</span></div>';
        html+='<div class="rh-price-row"><span class="rh-price-tag recur">Recharges suivantes</span><span class="sub-price recur">'+(heroRecurring*heroItem.qty).toFixed(2)+'€</span></div></div>';
      } else {
        if(heroCompare>heroSub) html+='<span class="compare">'+heroCompare.toFixed(2)+'€</span>';
        html+='<span class="sub-price">'+heroSub.toFixed(2)+'€</span>';
        if(heroCompare>heroSub) html+='<span class="savings-label">Économisez '+Math.round((1-heroSub/heroCompare)*100)+'%</span>';
      }
      html+='</div></div></div>';
      html+='<div class="rh-desc">Selon vos habitudes, vous le recevrez exactement quand vous en avez besoin. Zéro charge mentale.</div></div>';
    }
  }
  // Zero mental load
  if(!isPDP){
    html+='<div class="zero-load"><div class="zl-emoji">🧠✨</div><div class="zl-title">Zéro charge mentale</div><div class="zl-desc">Tout arrive chez vous exactement quand vous en avez besoin. Sans y penser, sans jamais manquer de rien.</div></div>';
  }
  html+='<h3>'+(isPDP?'Complétez votre routine':'Ménage Éco sur mesure !')+'</h3>';
  html+='<p>'+items.filter(function(i){return i.checked;}).length+' produits sélectionnés pour vous</p></div>';
  // Cards
  if(isPDP){
    var crossItems=items.filter(function(i){return !i.pdpMatch;});
    if(crossItems.length>0){
      html+='<div class="crosssell-section"><div class="crosssell-header">Complétez votre routine</div><div class="crosssell-desc">Tout arrive exactement quand vous en avez besoin. Zéro charge mentale.</div>';
      var crossCadence={};
      crossItems.forEach(function(i){ var cadence=i.freq==='otp'?'otp':String(freqToDays(i.freq)); if(!crossCadence[cadence]) crossCadence[cadence]=[]; crossCadence[cadence].push(i); });
      var cadenceKeys=Object.keys(crossCadence).sort(function(a,b){ if(a==='otp') return 1; if(b==='otp') return -1; return parseInt(a)-parseInt(b); });
      cadenceKeys.forEach(function(ck){
        var group=crossCadence[ck], isOTP=ck==='otp';
        var checkedGroup=group.filter(function(i){return i.checked;});
        var groupPrice=checkedGroup.reduce(function(s,i){return s+getSubPrice(i)*i.qty;},0);
        if(isOTP){ if(checkedGroup.length===0) return; html+='<div class="shipment-box shipment-otp" data-cadence="otp"><div class="shipment-header"><span class="sh-icon">🛍️</span><span class="sh-label">Achat unique</span><span class="sh-total">'+groupPrice.toFixed(2)+'€</span></div>'; }
        else{
          var cadenceDays=parseInt(ck);
          var freqStr=cadenceDays<=120?(FREQ_LABELS[cadenceDays+'d']||'Tous les '+cadenceDays+' jours'):(FREQ_LABELS[Math.round(cadenceDays/30)+'m']||'Tous les '+Math.round(cadenceDays/30)+' mois');
          html+='<div class="shipment-box" data-cadence="'+cadenceDays+'"><div class="shipment-header"><span class="sh-icon">📦</span><span class="sh-label">'+freqStr+'</span><span class="sh-count">'+checkedGroup.length+' produit'+(checkedGroup.length!==1?'s':'')+'</span><span class="sh-total">'+(groupPrice>0?groupPrice.toFixed(2)+'€/envoi':'')+'</span></div>';
        }
        group.sort(function(a,b){return a.checked!==b.checked?(a.checked?-1:1):0;});
        group.forEach(function(i){html+=renderProductCard(i);});
        html+='</div>';
      });
      html+='</div>';
    }
  } else {
    var shipmentsMap={};
    items.forEach(function(i){ var sg=i.shipmentGroup||(PRODUCTS[i.key]?.otp?'otp':freqToDays(i.freq)); if(!shipmentsMap[sg]) shipmentsMap[sg]=[]; shipmentsMap[sg].push(i); });
    var shipmentKeys=Object.keys(shipmentsMap).sort(function(a,b){ if(a==='otp') return 1; if(b==='otp') return -1; return parseInt(a)-parseInt(b); });
    shipmentKeys.forEach(function(sk){
      var group=shipmentsMap[sk], isOTP=sk==='otp';
      var checkedGroup=group.filter(function(i){return i.checked;});
      var groupPrice=checkedGroup.reduce(function(s,i){return s+getSubPrice(i)*i.qty;},0);
      var isEmpty=checkedGroup.length===0;
      if(isOTP){ if(isEmpty) return; html+='<div class="shipment-box shipment-otp" data-cadence="otp"><div class="shipment-header"><span class="sh-icon">🛍️</span><span class="sh-label">Achat unique</span><span class="sh-total">'+groupPrice.toFixed(2)+'€</span></div>'; }
      else{
        var cadence=parseInt(sk);
        var freqStr2=cadence<=120?(FREQ_LABELS[cadence+'d']||'Tous les '+cadence+' jours'):(FREQ_LABELS[Math.round(cadence/30)+'m']||'Tous les '+Math.round(cadence/30)+' mois');
        html+='<div class="shipment-box'+(isEmpty?' shipment-empty':'')+'" data-cadence="'+cadence+'"><div class="shipment-header"><span class="sh-icon">📦</span><span class="sh-label">'+freqStr2+'</span><span class="sh-count">'+checkedGroup.length+' produit'+(checkedGroup.length!==1?'s':'')+'</span><span class="sh-total">'+(isEmpty?'':groupPrice.toFixed(2)+'€/envoi')+'</span></div>';
      }
      group.sort(function(a,b){return a.checked!==b.checked?(a.checked?-1:1):0;});
      group.forEach(function(i){html+=renderProductCard(i);});
      html+='</div>';
    });
  }
  // Summary
  var checked=items.filter(function(i){return i.checked;});
  var totalBefore=checked.reduce(function(s,i){return s+((i.compareAt||i.price)*i.qty);},0);
  var totalSub=checked.reduce(function(s,i){return s+getSubPrice(i)*i.qty;},0);
  var totalSavings=totalBefore-totalSub;
  var sortedChecked=checked.slice().sort(function(a,b){return freqToDays(a.freq||'30d')-freqToDays(b.freq||'30d');});
  html+='<div class="results-summary" id="summaryBox"><div class="summary-toggle" onclick="document.getElementById(\'summaryBox\').classList.toggle(\'open\')"><span class="st-label">Votre routine · '+checked.length+' produits</span><span class="st-arrow">▾</span></div>';
  html+='<div class="summary-details"><div class="summary-items">';
  sortedChecked.forEach(function(i){
    var rec=i.recurringPrice, iSub=(getSubPrice(i)*i.qty).toFixed(2);
    html+='<div class="summary-item"><span class="si-name">'+i.name+(i.qty>1?' ×'+i.qty:'')+'</span><span class="si-freq">'+i.freqLabel+'</span><span class="si-price">'+iSub+'€'+(rec?'<br><span class="si-recur">Recharges suivantes : '+(rec*i.qty).toFixed(2)+'€</span>':'')+'</span></div>';
  });
  html+='</div></div>';
  html+='<div class="summary-total-wrap"><div class="summary-total"><span>Votre routine personnalisée</span><span><span class="st-compare">'+totalBefore.toFixed(2)+'€</span> '+totalSub.toFixed(2)+'€</span></div>';
  html+='<div class="summary-savings">Vous économisez '+totalSavings.toFixed(2)+'€ avec votre abonnement</div></div>';
  html+=buildRecurringBreakdownHTML(sortedChecked);
  html+='</div>';
  // CTA
  html+='<div class="results-cta"><button class="cta-main" onclick="window._ntlQuizFR.addToCart()">Tout ajouter au panier 🛒</button></div>';
  container.innerHTML=html;
  dbg('Results FR: '+items.length+' items, '+checked.length+' checked, '+totalSub.toFixed(2)+'€');
}

// ══════════════════════════════════════════
// INTERACTIONS
// ══════════════════════════════════════════

function selectFragrance(key,frag,el){
  var prodChk=PRODUCTS[key];
  if(prodChk&&prodChk.variantAvail&&prodChk.variantAvail[frag]===false) return; // rupture — sélection bloquée
  selectedFragrances[key]=frag;
  el.parentElement.querySelectorAll('.pc-frag-opt').forEach(function(o){o.classList.remove('active');});
  el.classList.add('active');
  var prod=PRODUCTS[key];
  if(prod&&prod.variantImages&&prod.variantImages[frag]){
    var newSrc=prod.variantImages[frag];
    var cardImg=getEl('img_'+key); if(cardImg) cardImg.innerHTML='<img src="'+newSrc+'" alt="'+prod.name+'" onerror="this.parentElement.textContent=\'📦\'">';
    var heroImg=document.querySelector('.ntl-quiz .rh-product-img'); if(heroImg) heroImg.innerHTML='<img src="'+newSrc+'" alt="'+prod.name+'">';
  }
}
function toggleCard(key){ var el=getEl('pc_'+key); if(el) el.classList.toggle('checked'); updateSummary(); }
function chgQty(key,d){ var el=getEl('qty_'+key); if(!el) return; var v=parseInt(el.textContent)+d; if(v<1)v=1; if(v>10)v=10; el.textContent=v; updateSummary(); }

function updateSummary(){
  var checked=[];
  resultItems.forEach(function(item){
    var card=getEl('pc_'+item.key);
    if(card){ if(!card.classList.contains('checked')) return; var qtyEl=card.querySelector('.qty'); var qty=qtyEl?parseInt(qtyEl.textContent):item.qty; checked.push(Object.assign({},item,{qty:qty})); }
    else if(item.pdpMatch) checked.push(Object.assign({},item));
  });
  var totalBefore=checked.reduce(function(s,i){return s+((i.compareAt||i.price)*i.qty);},0);
  var totalSub=checked.reduce(function(s,i){return s+getSubPrice(i)*i.qty;},0);
  var totalSavings=totalBefore-totalSub;
  var sorted=checked.slice().sort(function(a,b){return freqToDays(a.freq||'30d')-freqToDays(b.freq||'30d');});
  var toggleLabel=document.querySelector('.ntl-quiz .st-label'); if(toggleLabel) toggleLabel.textContent='Votre routine · '+checked.length+' produits';
  var itemsContainer=document.querySelector('.ntl-quiz .summary-items');
  if(itemsContainer){ var html=''; sorted.forEach(function(i){ var rec=i.recurringPrice,iSub=(getSubPrice(i)*i.qty).toFixed(2); html+='<div class="summary-item"><span class="si-name">'+i.name+(i.qty>1?' ×'+i.qty:'')+'</span><span class="si-freq">'+i.freqLabel+'</span><span class="si-price">'+iSub+'€'+(rec?'<br><span class="si-recur">Recharges suivantes : '+(rec*i.qty).toFixed(2)+'€</span>':'')+'</span></div>'; }); itemsContainer.innerHTML=html; }
  var totalDiv=document.querySelector('.ntl-quiz .summary-total'); if(totalDiv) totalDiv.innerHTML='<span>Votre routine personnalisée</span><span><span class="st-compare">'+totalBefore.toFixed(2)+'€</span> '+totalSub.toFixed(2)+'€</span>';
  var savingsDiv=document.querySelector('.ntl-quiz .summary-savings'); if(savingsDiv) savingsDiv.textContent='Vous économisez '+totalSavings.toFixed(2)+'€ avec votre abonnement';
  var rbDiv=getEl('recurBreakdown'), newRbHTML=buildRecurringBreakdownHTML(sorted);
  if(newRbHTML){ if(rbDiv){var wasOpen=rbDiv.classList.contains('open');rbDiv.outerHTML=newRbHTML;if(wasOpen){var nr=getEl('recurBreakdown');if(nr)nr.classList.add('open');}} else{var totalWrap=document.querySelector('.ntl-quiz .summary-total-wrap');if(totalWrap)totalWrap.insertAdjacentHTML('afterend',newRbHTML);} } else if(rbDiv) rbDiv.remove();
  document.querySelectorAll('.ntl-quiz .shipment-box[data-cadence]').forEach(function(box){
    var checkedCards=box.querySelectorAll('.product-card.checked'), boxTotal=0;
    checkedCards.forEach(function(card){ var key=card.id.replace('pc_',''); var item=resultItems.find(function(i){return i.key===key;}); if(!item) return; var qty=parseInt(card.querySelector('.qty')?.textContent||item.qty); boxTotal+=getSubPrice(item)*qty; });
    var countEl=box.querySelector('.sh-count'), totalEl=box.querySelector('.sh-total');
    if(countEl) countEl.textContent=checkedCards.length+' produit'+(checkedCards.length!==1?'s':'');
    if(totalEl) totalEl.textContent=box.dataset.cadence==='otp'?boxTotal.toFixed(2)+'€':boxTotal.toFixed(2)+'€/envoi';
  });
}

// ══════════════════════════════════════════
// CART
// ══════════════════════════════════════════

function getVariantId(key){
  var prod=PRODUCTS[key]; if(!prod||!prod.variants) return null;
  var variants=prod.variants, keys=Object.keys(variants);
  if(keys.length===1) return variants[keys[0]];
  if(prod.hasFragrance){ var frag=selectedFragrances[key]||keys[0]; return variants[frag]; }
  if(key==='flisflis'){ var heroCard=resultItems.find(function(i){return i.key==='flisflis';}); var sv=heroCard?.selectedVariant||'2 de chaque'; return variants[sv]||variants['2 de chaque']; }
  var multiVariantKeys=['antical','degraissant','vitres','multisurfaces','rec_antical','rec_multisurfaces'];
  if(multiVariantKeys.includes(key)){ var heroCard2=resultItems.find(function(i){return i.key===key;}); var sv2=heroCard2?.selectedVariant||'2'; return variants[sv2]||variants[keys[0]]; }
  return variants[keys[0]];
}

function getSellingPlanForItem(item){
  var entry=SELLING_PLANS[item.key];
  if(!entry||item.freq==='otp'||item.freqLabel==='Achat unique') return null;
  var sp;
  if(entry._multiVariant){
    var vid=item.selectedVariant?(PRODUCTS[item.key]?.variants?.[item.selectedVariant]||''):'';
    if(!vid){ var vKeys=Object.keys(PRODUCTS[item.key]?.variants||{}); vid=vKeys.length>0?PRODUCTS[item.key].variants[vKeys[0]]:''; }
    sp=entry[String(vid)]; if(!sp) return null;
  } else { sp=entry; }
  var freqKeys=Object.keys(sp).filter(k=>k!=='_multiVariant');
  if(item.freq&&sp[item.freq]) return {id:sp[item.freq],freq:item.freq};
  for(var i=0;i<freqKeys.length;i++){ if(FREQ_LABELS[freqKeys[i]]===item.freqLabel) return {id:sp[freqKeys[i]],freq:freqKeys[i]}; }
  var targetFreq=null;
  for(var j=0;j<Object.keys(FREQ_LABELS).length;j++){ var fk=Object.keys(FREQ_LABELS)[j]; if(FREQ_LABELS[fk]===item.freqLabel){targetFreq=fk;break;} }
  if(!targetFreq) return {id:sp[freqKeys[freqKeys.length-1]],freq:freqKeys[freqKeys.length-1]};
  var targetDays=freqToDays(targetFreq), bestKey=freqKeys[0], bestDiff=Math.abs(freqToDays(freqKeys[0])-targetDays);
  for(var k=1;k<freqKeys.length;k++){ var diff=Math.abs(freqToDays(freqKeys[k])-targetDays); if(diff<bestDiff){bestDiff=diff;bestKey=freqKeys[k];} }
  return {id:sp[bestKey],freq:bestKey};
}

function addToCart(){
  var cartItems=[];
  if(mode.startsWith('pdp_')){
    var heroItem=resultItems.find(function(i){return i.pdpMatch;});
    if(heroItem){ var vid=getVariantId(heroItem.key), sp=getSellingPlanForItem(heroItem); if(vid){ var ci={id:parseInt(vid),quantity:heroItem.qty,properties:{_quiz_source:quizType,_quiz_country:'FR'}}; if(sp){ci.selling_plan=parseInt(sp.id);ci.properties._quiz_freq=sp.freq;} cartItems.push(ci); } }
  }
  document.querySelectorAll('.ntl-quiz .product-card.checked').forEach(function(card){
    var key=card.id.replace('pc_',''), qtyEl=card.querySelector('.qty'), qty=qtyEl?parseInt(qtyEl.textContent):1;
    var variantId=getVariantId(key); if(!variantId) return;
    if(cartItems.some(function(ci){return ci.id===parseInt(variantId);})) return;
    var item=resultItems.find(function(i){return i.key===key;}), sp=item?getSellingPlanForItem(item):null;
    var ci={id:parseInt(variantId),quantity:qty,properties:{_quiz_source:quizType,_quiz_country:'FR'},_name:item?item.name:key};
    if(sp){ci.selling_plan=parseInt(sp.id);ci.properties._quiz_freq=sp.freq;}
    cartItems.push(ci);
  });
  if(cartItems.length===0){dbg('Cart FR: nothing selected');return;}
  dbg('Cart FR: '+cartItems.length+' items');
  var ctaBtn=document.querySelector('.ntl-quiz .cta-main'); if(ctaBtn){ctaBtn.disabled=true;ctaBtn.textContent='Ajout en cours...';}

  // Add items one by one so a rupture de stock doesn't block the whole cart
  function addOneByOne(items, added, failed, idx){
    if(idx>=items.length){ onAllDone(added, failed); return; }
    var item=items[idx];
    var payload={id:item.id, quantity:item.quantity, properties:item.properties};
    if(item.selling_plan) payload.selling_plan=item.selling_plan;
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
      .then(function(res){
        if(!res.ok) return res.json().then(function(e){ failed.push(item._name||('ID '+item.id)); addOneByOne(items,added,failed,idx+1); });
        else return res.json().then(function(){ added++; addOneByOne(items,added,failed,idx+1); });
      })
      .catch(function(){ failed.push(item._name||('ID '+item.id)); addOneByOne(items,added,failed,idx+1); });
  }

  function onAllDone(added, failed){
    dbg('Cart FR: '+added+' added, '+failed.length+' failed');
    if(added===0){
      if(ctaBtn){ctaBtn.disabled=false;ctaBtn.textContent='Tout ajouter au panier 🛒';}
      _ntlShowStockBanner(failed, false);
      return;
    }
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_quiz_order:'true',_quiz_session:_quizSessionId,_quiz_country:'FR'}})}).catch(function(){});
    var totalChecked=resultItems?resultItems.filter(function(i){return i.checked;}).length:0;
    var level=added>=totalChecked?'full':added>0?'partial':'none';
    _klavIdentify({'Quiz > A acheté après le quiz':true,'Quiz > Conversion web':level});
    _klavTrack('Quiz Converti',{quiz_type:quizType,source:'web',country:'FR',items_added:added,total_recommended:totalChecked,conversion_level:level});
    _logToSheet([{action_type:'cart_added',applied:true,total_applied:added,optimization_level:level}]);
    _quizCompleted=true;
    var results={};
    resultItems.forEach(function(it){ var sp2=getSellingPlanForItem(it); if(sp2) results[it.key]={freq:sp2.freq,sellingPlan:sp2.id,qty:it.qty}; });
    try{sessionStorage.setItem('natulim_fr_quiz_results',JSON.stringify(results));}catch(e){}
    closeQuiz();
    if(failed.length>0) setTimeout(function(){ _ntlShowStockBanner(failed, true); }, 400);
    var sectionsUrl=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+'?sections=cart-drawer,cart-icon-bubble';
    fetch(sectionsUrl).then(function(r){return r.json();}).then(function(sections){
      Object.keys(sections).forEach(function(sectionId){ var el=document.getElementById('shopify-section-'+sectionId); if(el) el.innerHTML=new DOMParser().parseFromString(sections[sectionId],'text/html').body.innerHTML; });
      var drawer=document.querySelector('cart-drawer'); if(drawer&&typeof drawer.open==='function') drawer.open();
    }).catch(function(){ var drawer=document.querySelector('cart-drawer'); if(drawer&&typeof drawer.open==='function') drawer.open(); });
  }

  addOneByOne(cartItems, 0, [], 0);
}

function _ntlShowStockBanner(failed, partialSuccess){
  var existing=document.getElementById('ntl-stock-banner'); if(existing) existing.remove();
  var msg=partialSuccess
    ? '⚠️ Produit(s) temporairement indisponible(s) et non ajouté(s) : <strong>'+failed.join(', ')+'</strong>. Le reste de votre routine a bien été ajouté !'
    : '⚠️ Ces produits sont temporairement indisponibles : <strong>'+failed.join(', ')+'</strong>. Veuillez réessayer plus tard.';
  var banner=document.createElement('div');
  banner.id='ntl-stock-banner';
  banner.style.cssText='position:fixed;bottom:20px;left:50%;transform:translateX(-50%);background:#fff;border:2px solid #f0a500;border-radius:12px;padding:14px 20px;max-width:480px;width:90%;z-index:99999;font-size:13px;line-height:1.5;color:#333;box-shadow:0 4px 20px rgba(0,0,0,0.12);text-align:center;';
  banner.innerHTML=msg+'<br><button onclick="this.parentNode.remove()" style="margin-top:8px;background:none;border:none;font-size:12px;color:#999;cursor:pointer;text-decoration:underline;">Fermer</button>';
  document.body.appendChild(banner);
  setTimeout(function(){ if(banner.parentNode) banner.remove(); }, 8000);
}

// ══════════════════════════════════════════
// KLAVIYO PUSH
// ══════════════════════════════════════════

function pushKlaviyo(step){
  var profile=_klavBuildProfile();
  profile['Quiz > Dernière étape avant abandon']=step;
  _klavIdentify(profile);
  if(step==='completed'){
    _quizCompleted=true;
    _klavSubscribeConsent();
    var duration=_quizStartTime?Math.round((Date.now()-_quizStartTime)/1000):0;
    profile['Quiz > Complété']=true;
    profile['Quiz > Abandonné sans finir']=false;
    profile['Quiz > Date de complétion']=new Date().toISOString().split('T')[0];
    if(typeof resultItems!=='undefined'&&resultItems){
      var checked=resultItems.filter(i=>i.checked);
      profile['Quiz > Produits recommandés']=checked.map(i=>i.key).join(',');
      var totalSub=checked.reduce((s,i)=>s+((i.subPrice||i.price*(1-(i.discount||0)/100))*(i.qty||1)),0);
      profile['Quiz > Valeur mensuelle du plan (€)']=Math.round(totalSub*100)/100;
      profile['Quiz > Détail du plan (JSON)']=JSON.stringify(checked.map(i=>({name:i.name,freq:i.freqLabel||i.freq,price:Math.round((i.subPrice||i.price)*100)/100})));
    }
    _klavIdentify(profile);
    _klavTrack('Quiz Complété',{quiz_type:quizType,source:'web',country:'FR',products_recommended:checked?checked.map(i=>i.key):[],estimated_ticket:totalSub||0,duration:duration});
    if(typeof resultItems!=='undefined'&&resultItems){
      var completedRows=resultItems.filter(i=>i.freq&&i.freq!=='otp').map(i=>({action_type:'quiz_completed',product_key:i.key,product_name:i.name||'',recommended_freq:i.freq,applied:false,price:i.subPrice||i.price||0,total_recommended:checked?checked.length:0,estimated_monthly_value:totalSub||0,last_step:'RESULTS',steps_completed:flow?flow.length:0,quiz_duration:duration}));
      _logToSheet(completedRows);
    }
  }
}

function saveState(){ try{ sessionStorage.setItem('nq_fr_state',JSON.stringify({quizType:quizType,mode:mode,currentStep:currentStep,answers:answers,ts:Date.now()})); }catch(e){} }
function restoreState(){ try{ var s=JSON.parse(sessionStorage.getItem('nq_fr_state')); if(!s||Date.now()-s.ts>30*60*1000) return false; mode=s.mode;currentStep=s.currentStep;answers=s.answers; return true; }catch(e){return false;} }

// ══════════════════════════════════════════
// PUBLIC API
// ══════════════════════════════════════════

window._ntlQuizFR = {
  startQuiz:startQuiz, closeQuiz:closeQuiz, resetQuiz:resetQuiz,
  pickRadio:pickRadio, pickCheck:pickCheck, stepper:stepperFn,
  emailInput:emailInputFn, consentChange:consentChangeFn,
  goNext:goNext, goBack:goBack,
  toggleCard:toggleCard, chgQty:chgQty, selectFragrance:selectFragrance,
  addToCart:addToCart, answers:answers
};

// ── SELLING PLANS (populated dynamically by _fetchProductData) ──
var SELLING_PLANS = {};

// ── HANDLE → MODE (FR handles) ──
var HANDLE_TO_MODE = {
  'eco-feuilles-lessive-40-lavages':              'pdp_detergente',
  'pack-12x-boites-eco-feuilles-de-lessive':      'pdp_detergente',
  'oxi-clean':                                    'pdp_oxis',
  'oxi-white':                                    'pdp_oxis',
  'perles-parfumees':                             'pdp_perles',
  'refill-perles-parfumees':                      'pdp_rec_perles',
  'tablettes-lave-vaisselle':                     'pdp_pastillas',
  'pack-lave-vaisselle-a-main-ecologique':        'pdp_lavmano',
  'lave-vaisselle-a-main-ecologique':             'pdp_lavmanopoudre',
  'nettoyant-sols-en-feuilles-30-doses':          'pdp_friegasuelos',
  'pack-les-4-indispensables':                    'pdp_flisflis',
  'pack-anti-calcaire':                           'pdp_antical',
  'pack-degraissant':                             'pdp_degraissant',
  'pack-nettoyant-vitres':                        'pdp_vitres',
  'pack-multi-surfaces-1':                        'pdp_multisurfaces',
  'detachant-2-eponges':                          'pdp_detachant',
  'acide-citrique-nettoyant-multi-usage':         'pdp_acide',
  'oxi-clean-booster-de-lavage':                  'pdp_rec_oxis',
  'oxi-white-booster-de-lavage-blanchissant':     'pdp_rec_oxiwhite',
  'refill-acide-citrique-nettoyant-multi-usage-copie': 'pdp_rec_acide',
  'sachets-recharges-anti-calcaire':              'pdp_rec_antical',
  'sachets-recharges-multi-surfaces':             'pdp_rec_multisurfaces',
};

// ── INIT ──
document.addEventListener('click', function(e){
  var trigger=e.target.closest('[data-quiz-open]');
  if(trigger){ e.preventDefault(); startQuiz(trigger.getAttribute('data-quiz-open')||'landing_hom'); }
});
document.addEventListener('click', function(e){
  var trigger=e.target.closest('[data-quiz-product]');
  if(trigger){ e.preventDefault(); var handle=trigger.getAttribute('data-quiz-product'); var detectedMode=HANDLE_TO_MODE[handle]; if(detectedMode){ startQuiz(detectedMode); } else { dbg('No quiz mode for handle: '+handle); } }
});
document.querySelectorAll('[data-quiz-product]').forEach(function(el){
  var handle=el.getAttribute('data-quiz-product');
  if(!HANDLE_TO_MODE[handle]){ el.style.display='none'; dbg('Quiz trigger hidden — product not in FR quiz: '+handle); }
});
if(restoreState()){ dbg('Session FR restored'); }

})();
